// ************************************</editor-fold>
// VARIABLES
// ************************************<editor-fold>
// photoId: even numbers are female, odd are male
const users = [
    {name: 'Geraldine Thomas', photoId: 2},
    {name: 'Codey Forrest', photoId: 3},
    {name: 'Isabel Smith', photoId: 4},
    {name: 'Mark Laxton', photoId: 5},
    {name: 'Emma Wade', photoId: 2},
    {name: 'Codey Forrest', photoId: 3},
    {name: 'Rachel Davi', photoId: 4},
    {name: 'Oliver Blackshire', photoId: 5},
    {name: 'Freddy Essex', photoId: 3},
    {name: 'Laura Barnes', photoId: 4},
    {name: 'Danny Kalfa', photoId: 5},
    {name: 'Valia Brady', photoId: 2},
    {name: 'Andy Sturrock', photoId: 3},
    {name: 'Alex Porter', photoId: 4},
    {name: 'Mark Kennan', photoId: 5}
];
const posts = [
    {
        content: 'RoboGirl saves you the hassle of thinking of a present, they always like whatever you give them!',
        comments: ['Whenever mine disagrees I just switch her off, love it!', 'Haha #entrepreneur']
    },
    {
        content: 'I’ve saved so much money by investing in Robogirl because I never have to spend money on good clothes. She likes whatever I wear!',
        comments: ['Wish you could turn off the eye module sometimes', 'Sometimes I wear clashing colours #MadLad']
    },
    {
        content: '#robogirl always agrees with my restaurant choices, result!',
        comments: ['Finally someone else who loves 3D printed steak']
    },
    {
        content: 'NanoDoc is good and bad. Good because I never get ill again. Bad that can’t use being ill as an excuse to not go somewhere',
        comments: ['I just wish it worked with hangovers', 'I miss those sick days!']
    },
    {
        content: 'I never leave my house without my wallet ever again. Thanks MemoryBoost',
        comments: ['I remember very clearly the time before I got it.', 'MemoryBoost 1, Unfed cats 0']
    },
    {
        content: 'What’s the point in going outside ever again when you can put on the Optic Breach VR Suit?',
        comments: ['What it costs is worth it compared to the cost of going on holiday', 'Excited for the VR office expansion']
    },
    {
        content: 'raining outside again? no worries, I just live my life through vr',
        comments: ['Lol at people who still go out in the acid rain.']
    },
    {
        content: `I can eat meat and not feel guilty cos clean meat co doesn’t harm any animals, amazing!`,
        comments: ['It tastes the same!', 'I love it']
    },
    {
        content: 'using filtr8 means I don’t contribute to climate change – now I feel much better about travelling to mars.',
        comments: ['Haha nice, I miss snow.', 'Hope they do another flash sale on Mars flights soon #NeedAHoliday']
    },
    {
        content: 'Remember to not use Filtr8 when you do exercise, used it all up on a few runs!',
        comments: ['Does anyone know how to dispose of used ones?']
    },
    {
        content: 'I’m so glad I can stop being vegetarian now, with clean meat co I don’t have to eat mushroom burgers ever again!',
        comments: ['I hated mushrooms!!!']
    },
    {
        content: 'before I had the ampere model 7, I was constantly swerving potholes. now I can drive without thinking about them ever again.',
        comments: ['Autopilot mode is super, I don’t think at all when I drive', 'I’m sick of these things crashing into me while I cycle!']
    },
    {
        content: 'Overtaking has never been easier than in the Ampere Model 7. I can just fly over everybody.',
        comments: ['And to think I spent all that time learning how to do a hill-start...']
    },
    {
        content: 'I’m so glad that they’ve upgraded space travel. Was getting bored of going to the moon. Thanks Infinity Z',
        comments: ['The moon is boring, there’s nothing to do up there and the food sucks. 1 star.', 'To Infinity Z and beyond the moon']
    },
    {
        content: 'does anyone understand clean meat co? their burgers taste exactly the same as real beef??',
        comments: ['How do they do it?!', 'HOW!!?']
    },
    {
        content: 'Netflix and Chills  #loveRoboGirl',
        comments: ['She’s especially cold if you touch the metal bits']
    },
    {
        content: 'Eat Clean #CleanMeatco',
        comments: ['Eat clean and not even a bean']
    },
    {
        content: 'Live. Laugh. Love #RoboGirl',
        comments: ['Awh cuties <3', 'Does anyone have a spare charge cable?']
    },
    {
        content: 'Feel the difference #vrSuit',
        comments: ['#vrSuit is suitper , get it?']
    },
    {
        content: 'To #InfinityZ and beyond!',
        comments: ['I can’t wait to visit the moon!', 'Can I bring my Robogirl? Do you have to buy an extra ticket?']
    },
    {
        content: 'No appointment, no worry #NanoDoc',
        comments: ['I <3 mine']
    },
    {
        content: 'Saving the planet, one breath at a time #Filtr8',
        comments: ['Haha who can remember winter? What a time that was.']
    },
    {
        content: 'No animals were harmed in the making of this hashtag #CleanMeatCo',
        comments: ['#VeganDomination2029']
    }
    // {content: `OMG such a long day`, comments: ['wow']},
    // {content: `wow, I can't believe anything`, comments:  ['OMG', 'really?']},
    // {content: `yay it's friday`, comments: []},
];

const randomComments = [
    ['Super classic idea :)', 'Super thought out! Yup.'],
    ['This idea has navigated right into my heart.'],
    [`I'm going to take a nap`],
    ['Love your boldness =)'],
    ['such elegant.', 'Neat. So classic.', 'Extra nice :-)'],
    ['such elegant.'],
    ['Neat. So classic.'],
    ['Extra nice :-)'],
    ['magical m8'],
    ['I love this.'],
    ['This blew my mind.'],
    ['this is delightful'],
    ['OMG'],
    ['LOL'],
    ['ha!'],
    ['Just cool :-)', 'very cool indeed'],
    ['say what?', 'what?'],
    ['fab', 'Overly fab.', `It's strong not just fabulous!`],
    ['This is new school.', 'Sleek. So good.', 'great'],
    ['Mission accomplished.', `It's simple, friend.`],
    ['great'],
    ['Trying it now.', 'yup'],
    ['Such classic.'],
    ['Such classic.', 'Super classic idea :)'],
    ['blew my mind'],
    ['I adore', 'love it', '<3'],
    ['is it?', 'it is'],
    [`That's strong and nice.`, 'lol'],
    ['no way.', 'way.'],
    [`I'm in!`, 'yup'],
    ['Cool.', 'So fabulous.', 'ha!'],
    ['Yes yes yes yes yes yes.'],
    [],
    [],
    [],
    [],
    [],
    []
];

const mList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

let postedIDs = [];
// ************************************</editor-fold>
// EVENTS
// ************************************<editor-fold>
new EventDelegator([
    {
        selector: '#js-social',
        eventType: 'click',
        events:
            {
                addcomment: (e, d) =>
                {
                    addComment(e.target);
                },
                inputerror: (e, d) =>
                {
                    commentInputError(e.target, (d.inputerror === 'true'))
                },
                focuscomment: (e, d) =>
                {
                    focusCommentInput(e.target);
                },
                likepost: (e, d) =>
                {
                    likePost(e.target, (d.likepost === 'true'));
                },
                sharepost: (e, d) =>
                {
                    sharePost(e.target);
                },
                addpost: (e, d) =>
                {
                    addPost('say what?', 'Michael Bolton')
                }
            }
    }]);

$('#social__posts').popover({
    selector: "[data-sharepost='true']",
    trigger: 'focus'
});

// ************************************</editor-fold>
// FUNCTIONS
// ************************************<editor-fold>

function addComment(target)
{
    target = $(target);
    const input = target.siblings('input');
    const inputValue = input.val();
    const responsesContainer = target.parents('.social__post').find('.response__comments');

    if (inputValue === '' || inputValue === ' ')
    {
        commentInputError(input, false);
    }
    else
    {
        responsesContainer.append(generateComment(inputValue, false));
    }
}

function generateComment(comment, randomUser)
{
    const photoID = randomUser ? new Random_Number({min: 2, max: 5}).get() : 1;
    const animation = randomUser ? '' : 'animated bounceInRight';
    return `<div class="user-details ${animation}">
                <img src="assets/img/icon-user-${photoID}.svg">
                <div class="speech-bubble">${comment}</div>
            </div>`
}

function commentInputError(target, reset)
{
    reset ?
        $(target).attr('data-inputerror', 'false').removeClass('shake')
        :
        target.attr('data-inputerror', 'true').addClass('flash');
}

function focusCommentInput(target)
{
    $(target).siblings('.response__add-comment').find('input').focus();
}

function likePost(target, like)
{
    const self = $(target);
    target = self.siblings('.response__no-of-likes');

    let noOfLikes = target.attr('data-likes');
    noOfLikes = parseInt(noOfLikes, 10);
    noOfLikes += like ? 1 : -1;

    updateNoOfLikes(target, noOfLikes);

    self.attr('data-likepost', !like)
}

function updateNoOfLikes(target, noOfLikes)
{
    target.fadeOut(100);
    target.attr('data-likes', noOfLikes);
    target.fadeIn(100);
}

function sharePost(target)
{
    $(target).attr('data-sharepost', 'false');

    setTimeout(function ()
    {
        $('[data-sharepost]').popover('hide');
    }, 1000);
}

function returnTimeString(anyDay)
{
    const date = new Date();
    const month = mList[date.getMonth()];
    const day = !anyDay ?
        date.getDate()
        :
        (date.getDate() <= 3) ?
            new Random_Number({min: 0, max: date.getDate()}).get()
            :
            new Random_Number({min: date.getDate() - 3, max: date.getDate()}).get();
    // const time = date.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
    let hour, min;
    hour = date.getHours();
    hour = !anyDay ? hour : new Random_Number({min: 0, max: hour}).get();
    hour = (hour < 10) ? '0' + hour : hour;
    min = date.getMinutes();
    min = !anyDay ? min : new Random_Number({min: 0, max: min}).get();
    min = (min < 10) ? '0' + min : min;
    const AMPM = (hour < 12) ? 'AM' : 'PM';
    return `${month} ${day} at ${hour}:${min} ${AMPM}`;
}

/**
 * ADD POST
 * @param {string} content - content for post
 * @param {string} user - name of user. OPTIONAL - will generate a random name if not passed.
 */
function addPost(content, user)
{
    const contentID = new Random_Number({min: 0, max: posts.length - 1, max_attempts: posts.length}).get();
    const target = $('#social__posts');
    const timeString = user ? returnTimeString(false) : returnTimeString(true);
    const shareable = user ? 'false' : 'true';
    const liked = user ? 0 : new Random_Number({min: 0, max: 36}).get();
    const userID = user ? 1 : new Random_Number({min: 0, max: users.length - 1}).get();
    const userName = user ? user : users[userID].name;
    const userPhotoID = user ? userID : users[userID].photoId;
    let comments;

    content = content ? content : posts[contentID].content;
    comments = user ? [] : postedIDs.includes(contentID) ? randomComments[liked] : posts[contentID].comments;
    postedIDs = [...postedIDs, contentID];

    if (comments.length <= 0)
    {
        comments = '';
    }
    else
    {
        let commentMarkup = '';
        for (const c of comments)
        {
            commentMarkup += generateComment(c, true);
        }
        comments = commentMarkup;
    }
    const postMarkup = `<div class="social__post animated fadeInDown">
                            <div class="user-details">
                                <img src="assets/img/icon-user-${userPhotoID}.svg" alt="">
                                <h4>${userName}</h4>
                                <h5>${timeString}</h5>
                            </div>
                            <p class="post__content">
                                ${content}
                            </p>
                            <div class="post__response">
                                <span class="response__no-of-likes animated faster" data-likes="${liked}">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                         viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;"
                                         xml:space="preserve">
                                        <g transform="translate(-326 -2391)">
                                                <circle class="st0" cx="334" cy="2399" r="8"/>
                                                <path class="st1" d="M338.4,2397.5h-2.1c0.1-0.7,0.1-1.4,0-2.1c-0.1-0.5-0.3-0.9-0.6-1.3c-0.2-0.2-0.6-0.1-0.8,0.1c0,0,0,1.1,0,1.4
                                                    c-0.1,0.5-0.4,0.9-0.7,1.2c-0.2,0.1-1.2,0.5-1.4,0.7v4.8l4.3,0c0.8,0,1.1-1,0.5-1.1l0-0.1c0.5-0.1,0.9-0.9,0.3-1.1l0-0.1
                                                    c0.5-0.1,1-0.9,0.3-1.1l0-0.1c0.6-0.1,0.9-1.1,0.2-1.1 M330,2398.2h2.1v4.8H330L330,2398.2z"/>
                                            </g>
                                    </svg>
                                </span>
                                <a class="response__action" data-likepost="true"><i class="far fa-thumbs-up"></i> like</a>
                                <a class="response__action" data-focuscomment><i class="fas fa-comment-alt"></i> comment</a>
                                <a class="response__action" data-placement="top" tabindex="0" role="button" data-toggle="popover" data-trigger="focus" data-content="we will share this with everyone" data-sharepost="${shareable}"><i class="fas fa-share"></i> share</a>
                                <div class="response__add-comment">
                                    <div>
                                        <img src="assets/img/icon-user-1.svg" alt="">
                                    </div>
                                    <input class="animated" type="text">
                                    <button data-addcomment>send</button>
                                </div>
                                <div class="response__comments">
                               ${comments}
                                </div>
                            </div>
                        </div>`;
    user ? target.prepend(postMarkup) : target.append(postMarkup);
}


let automatedPostCountdown, automatedPostCountdownInterval, automatedPostPosted;
automatedPostCountdown = 300000;
automatedPostPosted = false;


function postAutomatedPost(cancel)
{
    const automatedPostTitle = $('#post__automated-post');
    cancel ? automatedPostTitle.html('automated post has been cancelled') : automatedPostTitle.html('automated post has been posted');
    cancel ? automatedPostTitle.siblings().slideUp() : automatedPostTitle.siblings('.post__disable-auto-post').slideUp();
    automatedPostTitle.siblings('.post__container').removeClass('post__container--unposted');
    clearInterval(automatedPostCountdownInterval);
    automatedPostPosted = true;
}

function start_social_timer(start) {
    if (!automatedPostPosted && start) {
        automatedPostCountdownInterval = setInterval(function ()
        {
            let minutes, seconds;
            minutes = Math.floor((automatedPostCountdown % (1000 * 60 * 60)) / (1000 * 60));
            minutes = (minutes < 10) ? '0' + minutes : minutes;
            seconds = Math.floor((automatedPostCountdown % (1000 * 60)) / 1000);
            seconds = (seconds < 10) ? '0' + seconds : seconds;
            $('#automated-post-countdown').html(`${minutes}:${seconds}`);
            automatedPostCountdown -= 1000;

            if (automatedPostCountdown <= 0)
            {
                postAutomatedPost();
            }
        }, 1000);
    } else {
        clearInterval(automatedPostCountdownInterval);
    }

}

let delayPostLoad = false;
$(window).scroll(function ()
{
    if (!delayPostLoad && ($('#js-social').hasClass('active')) && ($(window).scrollTop() + $(window).height() > $(document).height() - 5))
    {

        delayPostLoad = true;
        setTimeout(function ()
        {
            addPost();
            addPost();
            addPost();
            delayPostLoad = false;
        }, 1000);
    }
});
